import axios from "axios";

const token = !localStorage.getItem("token")
  ? false
  : localStorage.getItem("token");
if (token) axios.defaults.headers.get["Authorization"] = "Bearer " + token;

const config = {
  baseURL: "https://us-central1-enercred.cloudfunctions.net",
  headers: {
    "Access-Control-Allow-Origin": "*",
    Authorization: "Bearer " + token,
  },
};

export const sendSMSCartao = async (email, phone) =>
  await axios.post("/sendSMSCartao", { email: email, tel: phone }, config);
export const sendSMS = async (msg, phone) =>
  await axios.post("/sendSMS", { msg: msg, tel: phone }, config);
